import { useEffect } from "react";
import { createFileRoute, Navigate } from "@tanstack/react-router";

import { openAdminDialog } from "#app/lib/admin-dialog-context";

/**
 * `/admin` is a deep link, not a page: it asks for the admin console and
 * hands off to the app index, which lands the user in their active
 * workspace, where the console mounts as an overlay over the page. The open
 * request is latched by the emitter until that mount exists. A
 * non-superuser simply lands in their workspace — the dialog renders
 * nothing for them.
 */
function Admin() {
  useEffect(() => {
    openAdminDialog();
  }, []);

  return <Navigate replace to="/" />;
}

export const Route = createFileRoute("/(app)/admin")({
  component: Admin,
  staticData: { standardAppearance: true },
});
